
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { BindLocationWithMultiplePlansJobRequest, CalculatePlanETARequest } from "../../domain";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class BindLocationWithMultiplePlansJobUsecase implements UseCase<BindLocationWithMultiplePlansJobRequest, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: BindLocationWithMultiplePlansJobRequest): Observable<boolean> {
    return this.planRepository.bindLocationWithMultiplePlanJob(params);
  }

}
